import React, { useState } from "react";
import useGlobalStore from "../stores/globalStore";
import SeeMore from "./SeeMore";

function SakerhetCard({ data }) {
   //State
   const [isOpen, setIsOpen] = useState(false);
   //Stores
   const selectedSecurity = useGlobalStore((state) => state.selectedSecurity);
   const setSelectedSecurity = useGlobalStore((state) => state.setSelectedSecurity);
   const resetSelectedSecurity = useGlobalStore((state) => state.resetSelectedSecurity);

   //Functions
   const handleSeeMore = () => {
      setIsOpen(!isOpen);
   };

   const handleCardSelection = (e) => {
      setSelectedSecurity(data);
      if (selectedSecurity.id === data.id) {
         resetSelectedSecurity();
      }
   };

   return (
      <div
         key={data.id}
         className={
            selectedSecurity.id === data.id
               ? `tel-pt-card selected tel-pt-${data.type}-card `
               : ` tel-pt-card tel-pt-${data.type}-card `
         }
         onClick={(e) => handleCardSelection(e)}
      >
         <div className="tel-pt-card__content">
            {data.image && <div className="tel-pt-card__image" style={{ backgroundImage: `url(${data.image})` }}></div>}

            <div className="tel-pt-card__info">
               <h3 className="tel-pt-card__title">{data.title.replace(/&#038;/g, "&")}</h3>
               {data.description && (
                  <p className="tel-pt-card__description" dangerouslySetInnerHTML={{ __html: data.description }} />
               )}
            </div>
            {(data.price || data.monthly_price) && (
               <div className="tel-pt-card__price-container">
                  <p className="tel-pt-card__price">
                     {data.price || data.monthly_price}
                     {data.type === "sakerhet" ? "kr/mån" : "kr"}
                  </p>
               </div>
            )}
         </div>

         {data.channels && !data.title.includes("Flex") ? (
            <div className="tel-pt-channels" onClick={() => handleSeeMore()}>
               <h4 className="tel-pt-channels__title">Kanaler</h4>
               {data.description && (
                  <p className="tel-pt-card__description" dangerouslySetInnerHTML={{ __html: data.description }} />
               )}
               <SeeMore isOpen={isOpen} />
               <ul className={isOpen ? "tel-pt-channels__list" : "tel-pt-channels__list not-visible"}>
                  {data.channels.map((kanal) => (
                     <li
                        className={
                           !kanal?.image ? "tel-pt-channels__list-item tel-pt-channels__no-image" : "tel-pt-channels__list-item"
                        }
                        key={kanal?.id}
                     >
                        {kanal?.image && <img className="tel-pt-channels__image" src={kanal?.image} />}
                        {kanal?.title}
                     </li>
                  ))}
               </ul>
            </div>
         ) : null}
      </div>
   );
}

export default SakerhetCard;